import { SxProps, Theme } from "@mui/material";

export const crashCourseFormStyles: SxProps<Theme> = {
  p: 3,
  backgroundColor: "background.paper",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  maxWidth: 600,
  mx: "auto",
};

export const ButtonStyles: SxProps = {
  backgroundColor: "#06B6D4",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#06B6D4CC",
  },
};

export const formTitleStyles: SxProps<Theme> = {
  color: "primary.main",
};

export const formDescriptionStyles: SxProps<Theme> = {
  mb: 3,
};

export const formFieldStyles: SxProps<Theme> = {
  mb: 2,
};

export const submitButtonContainerStyles: SxProps<Theme> = {
  mt: 3,
  display: "flex",
  justifyContent: "flex-end",
};

export const submitButtonStyles: SxProps<Theme> = {
  backgroundColor: "#06B6D4",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#06B6D4CC",
  },
};
